import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark";
import AgeWiseStocksChart from "../../../Components/Charts/AgeWiseStocksChart";

const stock_age = async (body) => {
  try {
    const res = await axInst.post("stocks/age-wise-stocks", body);
    const transformedData = res.data.age_wise_stocks
      .map((item) => ({
        name: item.key,
        value: item.doc_count,
      }))
      .reverse();

    return transformedData;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch age-wise stock data");
  }
};

const StockAge = () => {
  const { data, submitted } = useSelector((e) => e.filtersStock);
  const {
    data: Age,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["age", submitted],
    queryFn: () => stock_age(data),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  return (
    <div className="relative p-2">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />
      {!isFetching && !isError && Age && (
        <div>
          <AgeWiseStocksChart data={Age} heading="Age Wise Stocks" />
        </div>
      )}
    </div>
  );
};

export default StockAge;
